import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { TripAttributesGps } from '../dto/visit-gps.interface';

/**
 * TimeStamp Cell Renderer
 *
 * Muestra el timestamp más reciente de las ubicaciones del viaje.
 *
 * @example
 * ```typescript
 * {
 *   field: 'timestamp',
 *   headerName: 'Última réplica',
 *   cellRenderer: TimeStampCellRendererComponent,
 *   minWidth: 250
 * }
 * ```
 */
@Component({
  selector: 'app-timestamp-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  providers: [FormatOtherDateHourPipe],
  template: `
    <div class="leading-tight">
      <span class="font-descrip">
        {{ formatHour() }}
      </span>
    </div>
  `,
})
export class TimeStampCellRendererComponent implements CellRenderer<TripAttributesGps> {
  @Input() params!: CellRendererParams<TripAttributesGps>;

  constructor(private formatPipe: FormatOtherDateHourPipe) {}
  
  /**
   * Retorna el timestamp más reciente de locations.
   */
  getLastReplicaTimestamp(): string | null {
    const locations = this.params.data?.locations;
    if (!locations || locations.length === 0) {
      return null;
    }

    // Ordenamos por timestamp (más reciente primero)
    const sorted = [...locations].sort((a, b) => {
      const currentTimestamp = new Date(a.timestamp).getTime();
      const comparedTimestamp = new Date(b.timestamp).getTime();
      return comparedTimestamp - currentTimestamp;
    });

    return sorted[0].timestamp;
  }

  formatHour(): string {
    const ts = this.getLastReplicaTimestamp();
    return this.formatPipe.formatHour(ts ?? '');
  }
}
